module.exports = __webpack_public_path__ + "img/num3.850c40b4.png";